import {
  FilterChangeArgs,
  SelectedFilters
} from '@/fo/ui/product/layout/catalog';

export const updateFilters = (
  currentFilters: SelectedFilters,
  args: FilterChangeArgs
): SelectedFilters => {
  const { slug, value, checked } = args;
  let updatedFilters = { ...currentFilters };

  if (slug === 'price' && Array.isArray(value)) {
    updatedFilters = {
      ...updatedFilters,
      [slug]: value
    };
    return updatedFilters;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return Object.fromEntries(
        Object.entries(updatedFilters).filter(([key]) => key !== slug)
      );
    }

    return {
      ...updatedFilters,
      [slug]: value
    };
  }

  if (checked !== undefined) {
    const currentValues = (updatedFilters[slug] as string[]) || [];

    if (!Array.isArray(currentValues)) return updatedFilters;

    const newValues = [...currentValues];

    if (checked) {
      if (!newValues.includes(value as string)) {
        newValues.push(value as string);
      }
    } else {
      const idx = newValues.indexOf(value as string);
      if (idx !== -1) {
        newValues.splice(idx, 1);
      }
    }

    if (newValues.length === 0) {
      return Object.fromEntries(
        Object.entries(updatedFilters).filter(([key]) => key !== slug)
      );
    }

    return {
      ...updatedFilters,
      [slug]: newValues
    };
  }

  return updatedFilters;
};
